export default {
    base: {
        caretColor: '#0066FF'
    }
};
